<div
  class="hint"
  [class.hint--standalone]="standalone"
  [class.hint--error]="type === 'error'"
>
  <mat-icon
    class="hint__icon"
    [class.hint__icon--warning]="type === 'warning'"
  >
    {{ type === "error" || type === "warning" ? "error" : "info" }}
  </mat-icon>
  <ng-content />
</div>
